import { useState } from 'react'
const Map = () => {
    const [iframeLoading, setIframeLoading] = useState(true)

    const handleIframeLoad = () => {
        setIframeLoading(false)
    }

    return (
        <section className="map">
            {iframeLoading && <div className="loader-contact"></div>}

            <iframe
                src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.624999823781!2d-58.45403268477152!3d-34.563048980470064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb5d1feeacaab%3A0xb47c3541791e4eef!2sArcos%201824%2C%20C1428AFB%20CABA!5e0!3m2!1ses-419!2sar!4v1639615016318!5m2!1ses-419!2sar`}
                width="100%"
                height="350"
                title="Map"
                onLoad={handleIframeLoad}
                allowFullScreen
                loading="lazy"
                samesite="None"
                secure="true"
                style={iframeLoading ? { display: 'none' } : { display: 'block' }}
            ></iframe>
        </section>
    )
}

export default Map
